import React from 'react';
import RegistrationArea from "./RegistrationArea"
import "./Student.css"

function Student(props) {
    

    return (
        <div className = "studentContainer">
            <RegistrationArea/>
        </div>
    );
}


export default Student;